var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookSvgrepoCom5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.914,
    viewBox: "0 0 18 17.914",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook-svgrepo-com_5_",
    "data-name": "facebook-svgrepo-com (5)",
    transform: "translate(-0.993 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34577",
    "data-name": "Path 34577",
    d: "M18.993,10.012a9,9,0,1,0-10.4,8.9v-6.3H6.309v-2.6H8.593V8.027a3.178,3.178,0,0,1,3.4-3.507A13.78,13.78,0,0,1,14,4.7V6.914H12.87A1.3,1.3,0,0,0,11.4,8.322v1.69H13.9l-.4,2.6H11.4v6.3a9.008,9.008,0,0,0,7.59-8.9Z",
    transform: "translate(0 0)",
    fill: "#1877f2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookSvgrepoCom5);
export default __webpack_public_path__ + "static/media/facebook-svgrepo-com (5).a9bda95ffe2b022ace8ddcc3cf7e0668.svg";
export { ForwardRef as ReactComponent };